<template>
  <v-footer fixed>
    <span>
      &copy; 2019 Guang Yang
      <!-- &nbsp;<v-icon color="primary">whatshot</v-icon> -->
    </span>
  </v-footer>
</template>

<script>
  export default {
    name: "apps-footer"
  }
</script>

<style scoped>

</style>